import React from 'react';
import { recognizeItems } from '../data/content';
export function Recognize() {
  return <section className="w-full bg-sand px-5 py-20 sm:py-24" data-id="element-146" data-mp="30wohs94qq3vn">
      <div className="mx-auto max-w-4xl" data-id="element-147" data-mp="30zaz30hfnxr2">
        <div className="text-center" data-id="element-148" data-mp="2w5yfx5viwj5p">
          <h2 className="font-display text-[1.6rem] font-black uppercase leading-tight tracking-tight text-brand sm:text-[2.2rem]" data-id="element-149" data-mp="2w4wxuhg3aweh">
            Do These Situations Sound Familiar?
          </h2>
          <p className="mt-3 text-sm text-ink/60" data-id="element-150" data-mp="2m9vanr5dk4ej">
            If you answered yes to even one — Tennis Ready was built for you.
          </p>
        </div>

        <ul className="mt-9 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-151" data-mp="2d73whjl46uj7">
          {recognizeItems.map(item => <li key={item.text} className="flex items-start gap-3 rounded-xl bg-white px-4 py-4" data-id="element-152" data-mp="289c30l4tn0cw">
              <span className="text-base leading-none" aria-hidden="true" data-id="element-153" data-mp="be6bg9xkx68t">
                {item.emoji}
              </span>
              <span className="text-xs font-medium leading-snug text-ink/80" data-id="element-154" data-mp="3jl3l55kxyfoc">
                {item.text}
              </span>
            </li>)}
        </ul>

        <p className="mt-10 text-center font-display text-lg font-black uppercase tracking-tight text-lime-dark sm:text-xl" data-id="element-155" data-mp="3no0adf4zla19">
          You deserve better →
        </p>
      </div>
    </section>;
}